export enum StatusTypes {
    'ACTIVE' = 'ACTIVE',
    'DISABLED' = 'DISABLED',
    'BLOCKED' = 'BLOCKED',
    'DELETED' = 'DELETED',
  }
